import { render, staticRenderFns } from "./serversListView.vue?vue&type=template&id=5ccc74dd&"
import script from "./serversListView.vue?vue&type=script&lang=js&"
export * from "./serversListView.vue?vue&type=script&lang=js&"
import style0 from "./serversListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ccc74dd')) {
      api.createRecord('5ccc74dd', component.options)
    } else {
      api.reload('5ccc74dd', component.options)
    }
    module.hot.accept("./serversListView.vue?vue&type=template&id=5ccc74dd&", function () {
      api.rerender('5ccc74dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/serversListView.vue"
export default component.exports